@if (isLoading()) {
  <app-dots-loader></app-dots-loader>
} @else {
<app-nav-header></app-nav-header>
<div class="container">
  <div class="team-container">
    <div class="title">
      <h1>
        Meet our team of <i>developers</i>, <i>designers</i> and <i>innovators</i>.
      </h1>
      <p> A group of tech enthusiasts turning ideas into elegant, reliable software.</p>
    </div>
    <app-team-circle></app-team-circle>
  </div>
  <div class="flex-column-center">
    <div class="big-text" [class.visible]="isVisible" #element>Behind every successful company is a team of dedicated experts.</div>
    <div class="img-wrapper">
      <img src="assets/team/team-01.JPG">
    </div>
    <div class="founder-container">
      <div class="founder-title-block">Meet <span>Our Founder</span></div>
      <div class="founder">
        <div class="info-block">
          <div>
            <h2>Arthur Mnatsakanyan</h2>
            <h3>Founder & CEO</h3>
          </div>
          <img src="assets/team/quote.svg" width="32">
          <div class="subtitle">
            <p>
              We don’t just build software, we build the digital infrastructure that allows your business to scale.
            </p>
            <p>
              Our mission is to bridge the gap between complex technology and intuitive user experiences.
            </p>
          </div>
          <a href="https://www.linkedin.com/in/arturmnatsakanyann/" target="_blank">
            <i class="fab fa-linkedin-in"></i>
          </a>
        </div>
        <div class="image-block">
          <img src="assets/team/founder-photo.JPG" class="founder-image">
        </div>
      </div>
    </div>
    <div class="info-container">
      <div class="text-box">
<!--        <div class="text-box-title">Driven by Curiosity</div>
        <div class="text-box-subtitle">Defined by Results</div>-->
        <p>
          From the initial architecture to final global deployment, we are your dedicated technology partners every step of the way.
        </p>
      </div>
      <div class="image-container">
        <img src="assets/team/team-02.JPG">
        <div>Technology moves fast, and so do we.</div>
      </div>
    </div>
    <app-statistics></app-statistics>
    <app-contact-us></app-contact-us>
  </div>
</div>
<app-footer></app-footer>
}
